import { useNavigate, useLocation, NavLink } from 'react-router-dom';
import PropTypes from 'prop-types';
import {
  StyledContainer,
  StyledMenu,
  StyledList,
  StyledItem,
  StyledButton,
  StyledUserButton,
  StyledBackButton,
  StyledTitle,
} from './Header.styles';
import { Icon } from '../common/Icons';
import Wrapper from '../common/Wrapper/Wrapper';
import SearchBar from '../SearchBar/SearchBar';
import useScreenSize from '../../core/hooks/useScreenSize';

function Header({ title, isWhite, isNavHidden }) {
  const navigate = useNavigate();
  const location = useLocation();
  const [size] = useScreenSize();

  return (
    <StyledContainer isWhite={isWhite}>
      <Wrapper>
        {size > 991 ? (
          <NavLink className="home" to="/home">
            <span className="sr-only">Home</span>
            <Icon.Logo aria-hidden />
          </NavLink>
        ) : location.pathname === '/home' ? (
          <NavLink className="home" to="/home">
            <span className="sr-only">Home</span>
            <Icon.Logo aria-hidden />
          </NavLink>
        ) : (
          <>
            <StyledBackButton onClick={() => navigate(-1)} isWhite={isWhite}>
              <span className="sr-only">Go back</span>
              <Icon.Chevron aria-hidden />
            </StyledBackButton>
            <StyledTitle>{title}</StyledTitle>
          </>
        )}

        {size > 991 && <SearchBar searchQuery={() => {}} />}

        {(!isNavHidden || size > 991) && (
          <StyledMenu>
            <StyledList>
              <StyledItem>
                <NavLink to="/home">
                  <StyledButton>
                    <span className="sr-only">Home</span>
                    <Icon.Home aria-hidden />
                  </StyledButton>
                </NavLink>
              </StyledItem>
              <StyledItem>
                <NavLink to="/category">
                  <StyledButton>
                    <span className="sr-only">Explore</span>
                    <Icon.Explore aria-hidden />
                  </StyledButton>
                </NavLink>
              </StyledItem>
              <StyledItem>
                <NavLink to="/myJAAQ">
                  <StyledButton>
                    <span className="sr-only">My JAAQ</span>
                    <Icon.Jaaq aria-hidden />
                  </StyledButton>
                </NavLink>
              </StyledItem>
              <StyledItem>
                <NavLink to="/support">
                  <StyledButton>
                    <span className="sr-only">Support</span>
                    <Icon.Gift aria-hidden />
                  </StyledButton>
                </NavLink>
              </StyledItem>
            </StyledList>
          </StyledMenu>
        )}
        {size < 992 && (
          <StyledUserButton isWhite={isWhite}>
            <span className="sr-only">Toggle menu</span>
            <Icon.Menu aria-hidden />
          </StyledUserButton>
        )}
      </Wrapper>
    </StyledContainer>
  );
}

Header.propTypes = {
  title: PropTypes.string,
  isWhite: PropTypes.bool,
  isNavHidden: PropTypes.bool,
};

Header.defaultProps = {
  title: 'JAAQ',
  isWhite: false,
  isNavHidden: false,
};

export default Header;
